module.exports = __webpack_public_path__ + "img/app-store.32d44fb1.png";